import ReportView, { type ReportColumn } from '../../../components/reports/ReportView';

const COLUMNS: ReportColumn[] = [
  { key: 'changed_at', label: 'Changed At' },
  { key: 'investment_name', label: 'Investment' },
  { key: 'field', label: 'Field' },
  { key: 'old_value', label: 'Old Value' },
  { key: 'new_value', label: 'New Value' },
  { key: 'changed_by', label: 'Changed By' },
];

export function ChangeLogReport() {
  return (
    <ReportView
      title="Investment Change Log"
      description="Every logged field change across all investments, newest first."
      endpoint="/reports/investments/change-log"
      columns={COLUMNS}
      filters={['dateRange']}
      xlsx
    />
  );
}
